<template>
  <div
    :class="{ html2pdf__page: asContent }"
    :slot="asContent ? 'pdf-content' : null"
  >
    <section class="text-sm">
      <div class="relative">
        <table>
          <tr>
            <td>No. Koli</td>
            <td class="px-4">:</td>
            <td>{{ packet.code || packet.name || '-' }}/{{ total }}</td>
          </tr>
          <tr>
            <td>No. Faktur</td>
            <td class="px-4">:</td>
            <td>{{ stockMovement.order.code || '-' }}</td>
          </tr>
          <tr>
            <td>Tgl</td>
            <td class="px-4">:</td>
            <td>{{ stockMovement.date || '-' }}</td>
          </tr>
          <tr>
            <td>Kode Office Tujuan</td>
            <td class="px-4">:</td>
            <td>{{ stockMovement.order.destinationOffice || '-' }}</td>
          </tr>
          <template v-if="stockMovement.order.structuredAddress">
            <tr>
              <td>Kepada</td>
              <td class="px-4">:</td>
              <td>{{ stockMovement.order.structuredAddress.name || '-' }}</td>
            </tr>
            <tr>
              <td>Alamat</td>
              <td class="px-4">:</td>
              <td>{{ stockMovement.order.structuredAddress.shipment_address || stockMovement.order.structuredAddress.address || '-' }}</td>
            </tr>
            <tr>
              <td>HP</td>
              <td class="px-4">:</td>
              <td>{{ stockMovement.order.structuredAddress.phone || '-' }}</td>
            </tr>
          </template>
        </table>

        <template v-if="!stockMovement.order.structuredAddress">
          <p v-if="stockMovement.order.address">
            {{ stockMovement.order.address }}
          </p>
          <p v-else-if="stockMovement.order.name || stockMovement.order.phone">
            <span v-if="stockMovement.order.name">{{ stockMovement.order.name }}, </span>
            <span v-if="stockMovement.order.phone">{{ stockMovement.order.phone }}</span>
          </p>
        </template>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'PrintKoli',
  props: {
    total: [Number, String],
    asContent: {
      type: Boolean,
      default: true,
    },
    stockMovement: {
      type: Object,
      default: () => ({
        code: null,
        date: null,
        order: {
          code: null,
          address: null,
          phone: null,
          destinationOffice: null,
        },
        packets: [],
      }),
    },
    packet: {
      type: Object,
      default: () => ({
        code: null,
        name: null,
        products: [],
      }),
    },
  },
  methods: {},
};
</script>
